<template>
    <div>
        <div class="flex justify-center">
            <vs-card class="w-10/12 mt-5 shadow-lg card relative">
                <form ref="form" @submit.prevent="validate" class="flex flex-col items-center">
                    <div class="w-10/12 mt-10">
                        <h2 class="mb-4">Redeem Coupon</h2>

                        <vs-input
                            label="Email"
                            v-validate="'required|email'"
                            name="email"
                            v-model="details.email"
                            class="w-full mt-4"
                            placeholder="Enter email address"
                        />
                        <span class="text-danger text-sm" v-show="errors.has('email')">{{
                            errors.first('email')
                        }}</span>
                        <vs-input
                            label="Password"
                            v-validate="'required'"
                            type="password"
                            name="password"
                            class="w-full mt-4"
                            v-model="details.password"
                            data-vv-as="password"
                            placeholder="Password"
                            autocomplete="off"
                        />
                        <span class="text-danger text-sm" v-show="errors.has('password')">{{
                            errors.first('password')
                        }}</span>

                        <vs-input
                            disabled
                            label="Coupon Code"
                            v-validate="'required'"
                            name="coupon code"
                            class="w-full mt-4"
                            v-model="details.couponCode"
                            placeholder="Coupon Code"
                        />
                        <span class="text-danger text-sm" v-show="errors.has('coupon code')">{{
                            errors.first('coupon code')
                        }}</span>

                        <div v-show="showRedeemLink" class="text-sm pt-5">
                            Your email address doesnt seem to exist
                            <a
                                class="cursor-pointer font-bold"
                                @click="
                                    $router.push({
                                        name: 'redeem-register',
                                        params: { couponCode: couponCode }
                                    })
                                "
                                >click here to register</a
                            >
                        </div>
                        <div v-show="showResetPassword" class="text-sm pt-5">
                            Your credentials are incorrect
                            <a
                                class="cursor-pointer font-bold"
                                @click="$router.push('/account/forgot')"
                                >click here to reset your password</a
                            >
                        </div>
                    </div>

                    <img
                        src="@/assets/images/croc.png"
                        height="250"
                        alt="Croc Image"
                        class="croc"
                    />
                    <div class="absolute bottom-0 z-50 flex flex-col items-center mb-5">
                        <button type="submit" class="sign-up w-7/12 h-12 z-50 mt-5">Redeem</button>
                        <p class="mt-5 text-center z-50">
                            BY CONTINUING, YOU AGREE TO OUR <br />
                            <b> PRIVACY POLICY </b> AND <b> TERMS &amp; CONDITIONS </b>
                        </p>
                    </div>
                </form>
            </vs-card>
        </div>
    </div>
</template>

<script>
import { mapParams } from '@/plugins/mappers'

export default {
    name: 'coupon-redemption-existing',
    computed: {
        ...mapParams({
            couponCode: 'couponCode',
            email: 'email'
        })
    },
    watch: {
        couponCode: {
            handler(val) {
                if (val) {
                    this.details.couponCode = val
                }
            },
            immediate: true
        },
        email: {
            handler(val) {
                if (val) {
                    this.details.email = val
                }
            },
            immediate: true
        }
    },
    components: {},
    data() {
        return {
            loading: false,
            showRedeemLink: false,
            showResetPassword: false,
            details: {
                email: null,
                couponCode: null,
                password: null
            }
        }
    },
    methods: {
        validate() {
            this.$validator.validateAll().then(async (result) => {
                if (result) {
                    try {
                        this.showRedeemLink = false
                        this.showResetPassword = false
                        this.loading = true

                        const payload = {
                            remember: false,
                            username: this.details.email,
                            password: this.details.password,
                            preventRedirect: true
                        }
                        await this.$store.dispatch('auth/login', payload)

                        var response2 = await this.$api.coupon.redeemCoupon({
                            couponCode: this.details.couponCode
                        })

                        this.notifySuccess('Success', 'Coupon Redeemed successfully', 5000)
                        this.$router.replace({ path: '/success' })
                    } catch (err) {
                        console.error(err)
                        if (err == 404) {
                            this.notifyError(
                                'Account Error',
                                `User ${this.details.email} not found`,
                                5000
                            )
                            this.showRedeemLink = true
                            return
                        }

                        if (err == 401) {
                            this.notifyError(
                                'Account Error',
                                `Incorrect Credentials, please try again or reset your pasword.`,
                                5000
                            )
                            this.showResetPassword = true
                            return
                        }

                        if (err.status == 401 || err.status == 403) {
                            // unauthorised
                            this.notifyError('Account Error', `${err.data.title}`, 5000)
                            this.showRedeemLink = true
                            return
                        }

                        if (err.status == 409) {
                            // conflict
                            this.notifyError('Coupon Redemption Error', `${err.data.title}`, 5000)
                            return
                        }
                        if (err.status == 400) {
                            this.notifyError('Coupon Error', `${err.data.title}`, 5000)
                            return
                        }

                        this.notifyError('Error', `Something went wrong that shouldn't have.`, 5000)
                    } finally {
                        this.loading = false
                    }
                }
            })
        }
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Barlow:wght@300;400;500;600;700;800&family=Playfair+Display:wght@400;500;600;700;800&display=swap');
.croc {
    position: absolute;
    left: -50px;
    bottom: 0;
}
#logo {
    background-color: #b7dcc9;
}
.margin-left {
    margin-left: -180%;
}
.card {
    border-radius: 30px;
    min-height: 640px;
    max-width: 650px;
}
input {
    color: #949c9c;
}
input:focus {
    box-shadow: 0px 4px 10px -6px;
}
.border-bottom {
    border-top: none;
    border-left: none;
    border-right: none;
    border-color: #bcbdbe;
}
::placeholder {
    color: #bcbdbe;
}
.sign-up {
    border: none;
    border-radius: 50px;
    background-color: #9dd6cd;
    color: #fff;
    font-size: 1.5rem;
    box-shadow: 0px 2px 6px 0.5px #bebebe;
    cursor: pointer;
    font-family: 'Playfair Display', serif;
}
a {
    font-size: 1rem;
}
.error {
    color: #f72415;
}
p {
    color: #bcbdbe;
}
li {
    color: #949c9c;
    font-size: 1.2rem;
}
li span {
    font-size: 1rem;
}
@media only screen and (min-height: 1200px) {
    .card {
        height: 800px;
    }
    .height {
        height: 1202px;
    }
}
@media only screen and (max-width: 650px) {
    .croc {
        display: none;
    }
}
</style>
